import resolvePromise from '../helper/resolved_promise';
import { FilterActions } from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function showMobileFiltersAction() {
    Dispatcher.handleCatalogMobileFilterVisibilityAction({
        type: FilterActions.SHOW_MOBILE_FILTERS
    });

    return resolvePromise();
}

function hideMobileFiltersAction() {
    Dispatcher.handleCatalogMobileFilterVisibilityAction({
        type: FilterActions.HIDE_MOBILE_FILTERS
    });

    return resolvePromise();
}

export {
    showMobileFiltersAction,
    hideMobileFiltersAction
};